export const preChemoCheckupInitialValues = {
    checkupDate: null,
    ecogStatus: null,
    hemoglobin: null,
    hemoglobinDate: null,
    totalLeukocyte: null,
    totalLeukocyteDate: null,
    absoluteNeutrophil: null,
    absoluteNeutrophilDate: null,
    plateletCount: null,
    plateletCountDate: null,
    serumCreatinine: null,
    serumCreatinineDate: null,
    bloodUreaNitrogen: null,
    bloodUreaNitrogenDate: null,
    serumBilirubin: null,
    serumBilirubinDate: null,
    sgot: null,
    sgotDate: null,
    sgpt: null,
    sgptDate: null,
    sodium: null,
    sodiumDate: null,
    potassium: null,
    potassiumDate: null,
    cancerMarkers: null,
    cancerMarkersDate: null,
};

// Map API response to form values
export const mapPreChemoCheckupResponse = (data) => {
    if (!data) return preChemoCheckupInitialValues;

    return {
        checkupDate: data?.check_up_date || null,
        ecogStatus: data?.ecog_ps || null,
        hemoglobin: data?.haemoglobin || null,
        hemoglobinDate: data?.haemoglobin_date || null,
        totalLeukocyte: data?.leucocyte || null,
        totalLeukocyteDate: data?.leucocyte_date || null,
        absoluteNeutrophil: data?.neutrophil || null,
        absoluteNeutrophilDate: data?.neutrophil_date || null,
        plateletCount: data?.platelet || null,
        plateletCountDate: data?.platelet_date || null,
        serumCreatinine: data?.serum_creatinine || null,
        serumCreatinineDate: data?.serum_creatinine_date || null,
        bloodUreaNitrogen: data?.blood_urea_nitrogen || null,
        bloodUreaNitrogenDate: data?.blood_urea_nitrogen_date || null,
        serumBilirubin: data?.serum_bilirubin || null,
        serumBilirubinDate: data?.serum_bilirubin_date || null,
        sgot: data?.sgot || null,
        sgotDate: data?.sgot_date || null,
        sgpt: data?.sgpt || null,
        sgptDate: data?.sgpt_date || null,
        sodium: data?.sodium || null,
        sodiumDate: data?.sodium_date || null,
        potassium: data?.potassium || null,
        potassiumDate: data?.potassium_date || null,
        cancerMarkers: data?.cancer_markers || null,
        cancerMarkersDate: data?.cancer_markers_date || null,
    };
};